// Focused staging follow-up (PeerJS environment routing).
//
// VoiceCall.vue previously hardcoded the literal string
// 'peer.bornadanesh.com' as PeerJS's `host` option, regardless of
// environment, so a staging build's voice call signaled to PRODUCTION's
// peer service -- which correctly rejected it via its own
// PEER_ALLOWED_ORIGINS CORS allow-list (peer/cors-config.js), surfacing as
// a CORS failure rather than the underlying wrong-host bug.
//
// getPeerHost derives the bare hostname PeerJS's `host` option expects from
// config.peerRoot, a full origin consistent with the sibling VUE_APP_*
// config values (VUE_APP_SERVER_ROOT, VUE_APP_WEBSOCKET_ADDRESS, ...) --
// see .env.example and Dockerfile.production. Kept as its own module,
// rather than inline in VoiceCall.vue, so environment resolution is
// directly unit-testable without instantiating the component or mocking
// its peerjs/socket.io-client imports.
//
// NOT src/config/voice.js: that file's getPeerJSConfig() is unrelated dead
// code (unused, wrong host, a conflicting Google-STUN-only ICE set) left
// exactly as found -- its disposition is Task 03/ADR-001's canonical-
// signaling decision (HD-02), not this fix's to resolve.
import config from '@/config'

export function getPeerHost(peerRoot = config.peerRoot) {
  if (!peerRoot) {
    throw new Error(
      'VUE_APP_PEER_ROOT is not configured; cannot determine the PeerJS signaling host.'
    )
  }
  return new URL(peerRoot).hostname
}
